<div class="counters-container">
    <div class="displayed-folders-counter">
        <span>Nombre de dossiers affichés :</span>
        <span class="counter">{{ displayedFoldersCount }}</span>
    </div>
    <div class="total-folders-counter">
        <span>Nombre total de dossiers filtrés :</span>
        <span class="counter">{{ totalFoldersCount }}</span>
    </div>
</div>
